export enum FONT_WEIGHT {
  BOLD = 'bold',
  NORMAL = 'normal',
  BOLDER = 'bolder',
  LIGHTER = 'lighter'
}

export enum FONT_STYLE {
  ITALIC = 'italic',
  NORMAL = 'normal'
}

export enum ALIGNMENT {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum EDITABLE_TEXT_PROPERTIES {
  FONT_SIZE = 'fontSize',
  FONT_FAMILY = 'fontFamily',
  FILL = 'fill',
  FONT_WEIGHT = 'fontWeight',
  FONT_STYLE = 'fontStyle',
  UNDERLINE = 'underline',
  TEXT_ALIGN = 'textAlign',
  TEXT = 'text'
}
